import { createContext, useContext } from 'react'

export type TableContextType = {
  rounded?: boolean
  variant?: 'light' | 'primary' | 'dark'
  separators?: boolean
}

export const TableContext = createContext<TableContextType>({
  rounded: false,
  variant: 'light',
  separators: false,
})

export function useTable() {
  return useContext(TableContext)
}
